import { render, staticRenderFns } from "./SWVariants.vue?vue&type=template&id=7057a4d8&"
import script from "./SWVariants.vue?vue&type=script&lang=js&"
export * from "./SWVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports